import { useState, useEffect } from 'react'
import Translate from '../../i18n/Translate'

const ReservationButton = () => {
    const [fade, setFade] = useState(false)

    //Turn this on top in a useEffect
    useEffect(() => {
        //Para ocultar el boton si estamos a menos de 350px del botomm de la pagina
        const handleScroll = () => {
            if (window.innerHeight + Math.ceil(window.pageYOffset) >= document.body.offsetHeight - 350) {
                setFade(true)
            } else {
                setFade(false)
            }
        }
        window.addEventListener('scroll', handleScroll)

        return () => {
            window.removeEventListener('scroll', handleScroll)
        }
    }, [])

    return (
        <button className={`reservation-button  ${fade ? 'fade' : ''} `}>
            <a href="/#" target="_blank" rel="noopener noreferrer">
                <span>
                    <Translate langkey="itinerary_detail.reservation_button" />
                </span>
            </a>
        </button>
    )
}

export default ReservationButton
